export default "__VITE_ASSET__DpAqtDss__"